import RxProductContent from "./RxProductContent";

export default RxProductContent;
